module.exports = __webpack_public_path__ + "img/past.77be77f1.svg";